module.exports = __webpack_public_path__ + "img/default-avatar-doctor.befdf1bf.png";